import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { isObjectType, isInterfaceType, isInputObjectType, isEnumType, isScalarType, isUnionType } from "graphql";
import { MethodPill } from "@graphiql/react";
import { useDocExplorerActions } from "../context.js";
/* empty css                         */
function getTypeKindLabel(type) {
  if (isObjectType(type)) {
    return "TYPE";
  }
  if (isInterfaceType(type)) {
    return "INTERFACE";
  }
  if (isInputObjectType(type)) {
    return "INPUT";
  }
  if (isEnumType(type)) {
    return "ENUM";
  }
  if (isScalarType(type)) {
    return "SCALAR";
  }
  if (isUnionType(type)) {
    return "UNION";
  }
  return "TYPE";
}
const SchemaDocumentation = (t0) => {
  const $ = c(47);
  const {
    schema
  } = t0;
  const {
    push
  } = useDocExplorerActions();
  let t1;
  if ($[0] !== schema) {
    t1 = schema.getQueryType();
    $[0] = schema;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryType = t1;
  let t2;
  if ($[2] !== schema) {
    t2 = schema.getMutationType();
    $[2] = schema;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const mutationType = t2;
  let t3;
  if ($[4] !== schema) {
    t3 = schema.getSubscriptionType();
    $[4] = schema;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const subscriptionType = t3;
  const t4 = queryType == null ? void 0 : queryType.name;
  const t5 = mutationType == null ? void 0 : mutationType.name;
  const t6 = subscriptionType == null ? void 0 : subscriptionType.name;
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = new Set([t4, t5, t6].filter(Boolean));
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const rootTypeNames = t7;
  let t10;
  let t11;
  let t12;
  let t13;
  let t8;
  let t9;
  if ($[10] !== mutationType || $[11] !== push || $[12] !== queryType || $[13] !== rootTypeNames || $[14] !== schema || $[15] !== subscriptionType) {
    const allTypes = Object.values(schema.getTypeMap()).filter((type) => !type.name.startsWith("__") && !rootTypeNames.has(type.name));
    t10 = "graphiql-doc-explorer-schema-overview";
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-schema-section-header", children: "ROOT TYPES" });
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t142;
    if ($[23] !== push || $[24] !== queryType) {
      t142 = queryType && /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-schema-root-row", onClick: () => push({
        name: queryType.name,
        def: queryType
      }), children: [
        /* @__PURE__ */ jsx(MethodPill, { operation: "query", "aria-hidden": true }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-label", children: "Query" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-colon", children: ":" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-name", children: queryType.name })
      ] });
      $[23] = push;
      $[24] = queryType;
      $[25] = t142;
    } else {
      t142 = $[25];
    }
    let t152;
    if ($[26] !== mutationType || $[27] !== push) {
      t152 = mutationType && /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-schema-root-row", onClick: () => push({
        name: mutationType.name,
        def: mutationType
      }), children: [
        /* @__PURE__ */ jsx(MethodPill, { operation: "mutation", "aria-hidden": true }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-label", children: "Mutation" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-colon", children: ":" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-name", children: mutationType.name })
      ] });
      $[26] = mutationType;
      $[27] = push;
      $[28] = t152;
    } else {
      t152 = $[28];
    }
    let t16;
    if ($[29] !== push || $[30] !== subscriptionType) {
      t16 = subscriptionType && /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-schema-root-row", onClick: () => push({
        name: subscriptionType.name,
        def: subscriptionType
      }), children: [
        /* @__PURE__ */ jsx(MethodPill, { operation: "subscription", "aria-hidden": true }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-label", children: "Subscription" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-root-colon", children: ":" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-name", children: subscriptionType.name })
      ] });
      $[29] = push;
      $[30] = subscriptionType;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    if ($[32] !== t142 || $[33] !== t152 || $[34] !== t16) {
      t12 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-schema-root-types", children: [
        t142,
        t152,
        t16
      ] });
      $[32] = t142;
      $[33] = t152;
      $[34] = t16;
      $[35] = t12;
    } else {
      t12 = $[35];
    }
    if ($[36] !== allTypes) {
      t13 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-schema-section-header graphiql-doc-explorer-schema-section-header--types", children: [
        "ALL SCHEMA TYPES",
        /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-schema-type-count", children: [
          " ",
          "· ",
          allTypes.length
        ] })
      ] });
      $[36] = allTypes;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    t8 = "graphiql-doc-explorer-schema-all-types";
    t9 = allTypes.map((type_0) => /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-schema-type-row", onClick: () => push({
      name: type_0.name,
      def: type_0
    }), children: [
      /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-badge", children: getTypeKindLabel(type_0) }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-schema-type-name", children: type_0.name })
    ] }, type_0.name));
    $[10] = mutationType;
    $[11] = push;
    $[12] = queryType;
    $[13] = rootTypeNames;
    $[14] = schema;
    $[15] = subscriptionType;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t8;
    $[21] = t9;
  } else {
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t13 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t14;
  if ($[38] !== t8 || $[39] !== t9) {
    t14 = /* @__PURE__ */ jsx("div", { className: t8, children: t9 });
    $[38] = t8;
    $[39] = t9;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14) {
    t15 = /* @__PURE__ */ jsxs("div", { className: t10, children: [
      t11,
      t12,
      t13,
      t14
    ] });
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
};
export {
  SchemaDocumentation
};
//# sourceMappingURL=schema-documentation.js.map
